module.exports = __webpack_public_path__ + "img/med-c2.8a31cb63.svg";